import Iconify from "../../../components/minimal/iconify";
///components/minimal/iconify";
import { Box, Link } from "@mui/material";
import { useState, useEffect } from "react";

const ScrollForMore = ({ elementId }) => {
    // if page is scrolled to the top
    // show the scroll for more button
    // else hide it
    const [showScrollForMore, setShowScrollForMore] = useState(true);
    const handleScroll = () => {
        if (window.scrollY === 0) {
            // setShowScrollForMore(true);
        } else {
            setShowScrollForMore(false);
        }
    };
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const onClick = () => {
        // scroll to an element with the id
        const element = document.getElementById(elementId);
        element.scrollIntoView({ behavior: "smooth" });
    }

    return (
        <Box onClick={onClick} sx={{
            color: 'black',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            opacity: showScrollForMore ? 1 : 0,
            transition: `opacity 0.3s`,
            cursor: 'pointer',
        }} >
            <Box sx={{
                position: "fixed",
                bottom: '10vh',
                width: '40px',
                height: '60px',
                borderRadius: '25px',
                border: '2.5px solid black',
                display: 'flex',
                justifyContent: 'center',
                opacity: 0,
                '@keyframes fadeIn': {
                    '0%': {
                        opacity: 0
                    },
                    '100%': {
                        opacity: 0.6
                    }
                },
                // fade in after 5s
                animation: 'fadeIn 4s 4s forwards',
            }}>
                <Box sx={{
                    // slide down animation and fade out infintaely
                    // height: '20px',
                    padding: '10px',
                    animation: 'slideDown 1.8s infinite',
                    '@keyframes slideDown': {
                        '0%': {
                            opacity: 0,
                            transform: 'translateY(0)'
                        },
                        '25%': {
                            opacity: 1,
                        },
                        '75%': {
                            opacity: 1,
                        },
                        '100%': {
                            opacity: 0,
                            transform: 'translateY(20px)'
                        },
                    },
                }}>
                    <Iconify icon="mingcute:down-fill"
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default ScrollForMore;